export const BLOG_IMAGE_URL =
  'https://tenecesito-bucket.s3.us-west-1.amazonaws.com/static/assets/BlogIcon/blogIcon.png';

export const BLOG_IMAGE_BLUE_URL =
  'https://tenecesito-bucket.s3.us-west-1.amazonaws.com/static/assets/BlogIcon/blogIconBlue.png';
